import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Components
import UserSettings from '../Settings/UserSettings';

const EnrollSettings = observer(class EnrollSettings extends React.Component {
  render() {
    return(
      <div className={this.props.isActive}>
        <UserSettings
          enrollment={true}
          setStep={this.props.setStep}
          setDisplayStep={this.props.setDisplayStep}
          {...this.props}
        />
      </div>
    );
  }
})

export default translate('EnrollSettings')(EnrollSettings);


// WEBPACK FOOTER //
// ./src/app/components/Enroll/EnrollSettings.js